// Para local

// export const DOCUMENT_TYPE = 'api/documentType';
// export const NATIONALITY = 'api/nationality'
// export const LOGIN = 'api/auth/login'
// export const CLIENT = 'api/client'
// export const VALIDATE = (documentTypeId, document) => `api/auth/${documentTypeId}/${document}`
// export const VALIDDOCUMENT = (document) => `api/auth/${document}`
// export const CONFIRM_EMAIL = 'api/client/confirmEmail'
// export const REFRESH = 'api/auth/refresh'
// export const GETUSER = 'api/client/getUser'
// export const ENVIAR_PAGO = 'enviarPagoCarnet'
// export const FACTURA_DETALLE = 'api/facturaDetalle'
// export const FACTURA = 'api/factura'
// export const CHANGEPASSWORD = "api/auth/changePassword";

// Para APIGATEWAY

const DOCUMENT_TYPE = "api/documentType";
const NATIONALITY = "api/nationality";
const LOGIN = "authApi/auth/login";
const CLIENT = "api/client";
const CLIENT_INFO = "api/client/clientInfo";
const VALIDATE = (documentTypeId, document) =>
  `authApi/auth/${documentTypeId}/${document}`;
const VALIDDOCUMENT = (document) => `authApi/auth/${document}`;
const CONFIRM_EMAIL = "api/client/confirmEmail";
const REFRESH = "authApi/auth/refresh";
const GETUSER = "api/client/getUser";
const ENVIAR_PAGO = "web/sinap/enviarPagoCarnet";
const FACTURA_DETALLE = "api/sinap/facturaDetalle";
const FACTURA = "api/sinap/factura";
const CHANGEPASSWORD = "authApi/auth/changePassword";
const SERVICE_CLIENT = "api/serviceClient";
const PERSONA_CEDULA = (document) => `authApi/auth/personByCedula/${document}`;

export {
  DOCUMENT_TYPE,
  NATIONALITY,
  LOGIN,
  CLIENT,
  CLIENT_INFO,
  VALIDATE,
  VALIDDOCUMENT,
  CONFIRM_EMAIL,
  REFRESH,
  GETUSER,
  ENVIAR_PAGO,
  FACTURA,
  FACTURA_DETALLE,
  CHANGEPASSWORD,
  SERVICE_CLIENT,
  PERSONA_CEDULA,
};
